import useCommon from "@/shared/hooks/useCommon";
import Icon from "../Icon/Icon";
import IconButton from "../IconButton/IconButton";
import Tooltip from "@/Components/Tooltip/Tooltip";
import Center from "../Base/Center";

const PosSessionBackButton = ({ onClick, table }) => {
  const t = useCommon();
  return (
    <Tooltip content={t("goBack")}>
      <div>
        <div className="relative">
          <IconButton onClick={onClick} size="small">
            {table?.table_number}
          </IconButton>
          <Center className="absolute bottom-0 left-0 flex h-6 w-6 rounded-full bg-primary-dark z-10">
            <Icon className="h-3 w-3 fill-white" variants="arrowLeft" />
          </Center>
        </div>
      </div>
    </Tooltip>
  );
};

export default PosSessionBackButton;
